import React from 'react';
import Loader from '../../shared/components/common/Loader';

/** Full-screen loader for standalone routes (auth callback, etc.) */
export function PageLoader() {
  return <Loader fullscreen />;
}

